import { create } from 'zustand'

interface SubscriptionState {
  /** Сообщение для ученика при 403 subscription_required (подписка учителя приостановлена) */
  subscriptionRequiredMessage: string | null
  setSubscriptionRequiredMessage: (message: string | null) => void
}

export const useSubscriptionStore = create<SubscriptionState>((set) => ({
  subscriptionRequiredMessage: null,
  setSubscriptionRequiredMessage: (message) => set({ subscriptionRequiredMessage: message }),
}))
